import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { TrashIcon } from "@common/trashIcon";
import { EditIcon } from "@common/editIcon";
import { ContextualMenu } from "@common/contextualMenu";
import { useModal } from "@root/client/modal";
import { UseCases } from "@planzone/core";
import { Props } from "./types";
import { StrategicAxisCode } from "./tag";
import styles from "./styles.scss";

function StrategicAxis({ strategicAxis }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div className={styles.strategicAxis}>
      <div className={classNames(styles.value, styles.code)}>
        <StrategicAxisCode
          code={strategicAxis.code}
          color={strategicAxis.color}
        />
      </div>
      <p className={classNames(styles.value, styles.name)}>
        {strategicAxis.name}
      </p>
      <div className={styles.row}>
        <p className={styles.value}>
          {strategicAxis.adequacyPossibilities["-2"]}
        </p>
        <p className={styles.value}>
          {strategicAxis.adequacyPossibilities["-1"]}
        </p>
        <p className={styles.value}>
          {strategicAxis.adequacyPossibilities["0"]}
        </p>
        <p className={styles.value}>
          {strategicAxis.adequacyPossibilities["1"]}
        </p>
        <p className={styles.value}>
          {strategicAxis.adequacyPossibilities["2"]}
        </p>
      </div>
      <p className={classNames(styles.weight, styles.value)}>
        {strategicAxis.weight}
      </p>
      <div className={styles.contextualMenu}>
        <ContextualMenu
          items={[
            {
              name: t("strategicAxesPage.edit"),
              renderIcon: (className: string) => (
                <EditIcon className={className} />
              ),
              act: () =>
                pushView({
                  data: strategicAxis,
                  key: UseCases.editStrategicAxis,
                }),
            },
            {
              name: t("strategicAxesPage.remove"),
              renderIcon: (className: string) => (
                <TrashIcon className={classNames(className, styles.icon)} />
              ),
              color: "#db5f63",
              act: () =>
                pushView({
                  data: strategicAxis,
                  key: UseCases.removeStrategicAxis,
                }),
            },
          ]}
        />
      </div>
    </div>
  );
}

export { StrategicAxis };
